import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SessionService } from '../../../services/session.service';
import { SpinnerService } from 'shared-components';
import { SessionContextService } from '../../../context/session-context.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.component.html'
})
export class ChangeLanguageComponent implements OnInit {

  public languagesForm: UntypedFormGroup;
  public languages = [];
  public showLanguages = false;
  public showConfirmation = false;

  @Output() closeModal = new EventEmitter<boolean>();

  constructor(
    private _fb: UntypedFormBuilder,
    private readonly _translate: TranslateService,
    private readonly _sessionService: SessionService,
    private readonly _sessionContext: SessionContextService,
    private readonly _spinnerService: SpinnerService
  ) { }

  ngOnInit() {
    this.languagesForm = this._fb.group({
      pais: ['', Validators.required]
    });
    setTimeout (()=> this.getLanguages());
  }

  public getLanguages(){
    this._spinnerService.showSpinner();
    this._sessionService.getIdiomaAll().toPromise().finally(() => {
      this._spinnerService.hideSpinner();
    }).then((resp) => {
      resp = resp.filter(b => b.idiomaId == 1 || b.idiomaId == 2 || b.idiomaId == 4);
      resp.forEach(a=> {
        const defLang = this._translate.getDefaultLang();
        if(a.cultureInfo != defLang && !a.cultureInfo.includes(defLang)){
          this.languages.push({id: a.idiomaId, des: a.des, cultureInfo: a.cultureInfo});
        }
      });
      this.showLanguages = true;
    });
  }

  public changeLanguage(){
    this.showLanguages = false;
    this.showConfirmation = true;

  }

  public confirm(){
    const options = {
      userName: this._sessionContext.sessionUser.userName,
      idiomaId: this.languagesForm.get('pais').value.id
    };
    this._spinnerService.showSpinner();
    this._sessionService.changeIdiomaUser(options).toPromise().finally(() => {
      this._spinnerService.hideSpinner();
    }).then((resp) => {
      this._sessionContext.sessionUser['idiomaId'] = resp.idiomaId;
      localStorage.setItem('defaultLanguage',this.languagesForm.get('pais').value.cultureInfo);
      this.reloadPage();
    });
  }

  public reloadPage(){
    if(!localStorage.user && !localStorage.token) localStorage.setItem('refreshChangeLanguage', 'true');
    localStorage.user = JSON.stringify(this._sessionContext.sessionUser);
    localStorage.token = this._sessionContext.sessionToken;
    window.location.reload();
  }

}
